module.exports = __webpack_public_path__ + "img/successful-registration.329964fb.svg";